import React from "react";
import { withTranslation } from "react-i18next";
import { AddVehicle } from "./addVehicle";

class AddVehicleParent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {
        return <AddVehicle {...this?.props} />;
    }
}

export default withTranslation('vehicle')(AddVehicleParent);

